import ActiveUserContext from "../../utils/session/ActiveUserContext";
import FlexRow from "../../common/components/layout/Flexbox/FlexRow";
import PageFramework from "../../common/components/layout/PageFramework/PageFramework";
import RecentCharactersCard from "./components/RecentCharactersCard";
import RecentWikiActivityCard from "./components/RecentWikiActivityCard";
import { useContext } from "react";

import Book from "../../common/components/display/Book/Book";

import "./Home_style.css";

export default function Home(): JSX.Element {
    const activeUser = useContext(ActiveUserContext);

    return (
        <PageFramework>
            <FlexRow wrap={true} className="top-container">
                {activeUser.id >= 1 && (
                    <div className="recent-characters-container">
                        <RecentCharactersCard />
                    </div>
                )}
                <div className="recent-wiki-container">
                    <RecentWikiActivityCard />
                </div>
            </FlexRow>
            {/* <Book
                coverSrc={"https://ayaseye.com/hosted_images/Cover01.jpg"}
                pgSrcs={[
                    "https://ayaseye.com/hosted_images/Pix01.jpg",
                    "https://ayaseye.com/hosted_images/Pix02.jpg",
                    "https://ayaseye.com/hosted_images/Pix03.jpg",
                    "https://ayaseye.com/hosted_images/Pix04.jpg",
                    "https://ayaseye.com/hosted_images/Pix05.jpg",
                ]}
            /> */}
        </PageFramework>
    );
}
